// extracted by mini-css-extract-plugin
module.exports = {"label":"label-31Kt8","label--light":"label--light-1muhy","label--bold":"label--bold-2Eygl","label--error":"label--error-3FtUZ"};